// removed by extract-text-webpack-plugin
module.exports = {"patch-author":"AuthorLink__patch-author___2KIbQ","author-name":"AuthorLink__author-name___254u5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthorLink/AuthorLink.css
// module id = 344
// module chunks = 0